import isEqual from 'fast-deep-equal';
var getStorage = function getStorage() {
    var _localStorage_getItem;
    return JSON.parse((_localStorage_getItem = localStorage.getItem('debugBar-overloaded')) !== null && _localStorage_getItem !== void 0 ? _localStorage_getItem : '{}');
};
var resetStorage = function resetStorage() {
    localStorage.removeItem('debugBar-overloaded');
};
var setStorage = function setStorage(storeOverloaded) {
    localStorage.setItem('debugBar-overloaded', JSON.stringify(storeOverloaded));
};
var getByKey = function getByKey(key) {
    var storeOverloaded = getStorage();
    return storeOverloaded[key];
};
var isKeyActive = function isKeyActive(store, key) {
    var storeOverloaded = getStorage();
    if (storeOverloaded[key] === undefined) {
        return false;
    }
    return !isEqual(store[key], storeOverloaded[key]);
};
var resetByKey = function resetByKey(key) {
    var storeOverloaded = getStorage();
    storeOverloaded[key] = undefined;
    setStorage(storeOverloaded);
};
export var StoreOverloaded = {
    get: getStorage,
    getByKey: getByKey,
    isKeyActive: isKeyActive,
    reset: resetStorage,
    resetByKey: resetByKey,
    set: setStorage
};

//# sourceMappingURL=StoreOverloaded.js.map